import Image from '@base/Image';
import { ATTEMPT_STATES, MODAL_TYPES } from '@cont/Quiz/constants';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import { getModalState } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { useDispatch } from 'react-redux';
import { setModalState } from '@actions/quizTaking';
import Dynamic from '@base/Dynamic/Dynamic';

const DraggableCalculator = Dynamic(() =>
  import('@cont/Quiz/Taking/Common/DraggableCalculator')
);

const Wrapper = styled.div`
  width: 272px;
  position: absolute;
  top: 0;
  height: 145px;
  border-bottom: 1px solid var(--color-divider);
  margin-bottom: ${Spacings.SPACING_4B};
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  flex-wrap: wrap;
`;

const StateName = styled.div`
  line-height: 18px;
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.ULTRA_SMALL};
  color: var(--color-text-primary);
  margin-left: ${Spacings.SPACING_2B};
`;

const Flex = styled.div`
  display: flex;
  min-width: 102px;
  height: ${Spacings.SPACING_6B};
  align-items: center;
`;

const AttemptStates = () => {
  const dispatch = useDispatch();
  const modalState = useSelectorWithShallowEqual(getModalState);
  const showCalculator = modalState?.type === MODAL_TYPES.QUIZ_CALCULATOR;

  const resetModal = () => {
    dispatch(
      setModalState({
        type: null,
        data: {}
      })
    );
  };

  return (
    <Wrapper>
      {ATTEMPT_STATES.map((state) => (
        <Flex key={state.name}>
          <Image
            src={state.iconSrc}
            width="24"
            height="24"
            alt="attempt state"
          />
          <StateName>{state.name}</StateName>
        </Flex>
      ))}
      {showCalculator && (
        <DraggableCalculator
          type={modalState.data.calculatorType}
          show={showCalculator}
          onClose={resetModal}
          isTestRevampFlow={modalState.data.isTestRevampFlow}
        />
      )}
    </Wrapper>
  );
};

export default AttemptStates;
